import { forwardRef, useEffect } from "react";
import "../css/Modal.css";
import { X } from "react-feather";
import { createPortal } from "react-dom";
import { toast, ToastContainer } from "react-toastify";

const Modal = forwardRef(
  (
    {
      minWidth = "500px",
      minHeight = "",
      closeButton = true,
      children,
      onCloseCleanUp = () => {},
      clickOutSide = true,
    },
    ref
  ) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (clickOutSide) {
          console.log("clickOutSide", clickOutSide);
          if (ref?.current && event.target === ref.current) {
            onCloseCleanUp();
            ref.current.close();
          }
        }
      };

      const dialogElement = ref?.current;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "open"
          ) {
            const isOpen = dialogElement.hasAttribute("open");
            if (!isOpen) {
              console.log("Clearing queue");
              toast.dismiss();
            }
          }
        });
      });

      observer.observe(dialogElement, { attributes: true });

      if (dialogElement) {
        dialogElement.addEventListener("click", handleClickOutside);
      }

      return () => {
        if (dialogElement) {
          dialogElement.removeEventListener("click", handleClickOutside);
        }
      };
    }, [ref]);

    return createPortal(
      <dialog
        className="modal"
        style={{
          minWidth: minWidth,
          minHeight: minHeight,
          padding: closeButton ? "1rem" : "0",
        }}
        ref={ref}
      >
        {closeButton && (
          <div className="modal-close-container">
            <X
              className="modal-close"
              onClick={() => {
                if (ref?.current) {
                  onCloseCleanUp();
                  toast.dismiss();
                  ref.current.close();
                }
              }}
            />
          </div>
        )}
        <ToastContainer
          enableMultiContainer={true}
          containerId="Modal"
          hideProgressBar
          zIndex={2000}
        />
        {children}
      </dialog>,
      document.getElementById("modal")
    );
  }
);

export default Modal;
